import { useState } from 'react';
import { CheckCircle, XCircle } from 'lucide-react';
import { toast } from 'sonner';
import { axiosInstance } from '../App';

const ResolutionConfirmation = ({ queryId, status = 'pending_feedback', compact = false, onUpdated }) => {
  const [currentStatus, setCurrentStatus] = useState(status);
  const [saving, setSaving] = useState(false);

  if (!queryId || currentStatus !== 'pending_feedback') return null;

  const updateStatus = async (nextStatus) => {
    setSaving(true);
    try {
      const response = await axiosInstance.patch(`/queries/${queryId}/resolution-status`, { status: nextStatus });
      setCurrentStatus(nextStatus);
      onUpdated?.(response.data);
      toast.success(nextStatus === 'resolved' ? 'Marked as resolved' : 'Marked as unresolved');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to save feedback');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className={compact ? 'flex items-center gap-2 flex-wrap' : 'mt-5 flex flex-wrap items-center justify-between gap-3 rounded-lg border border-sky-200 bg-sky-50 px-4 py-3'} data-testid={`resolution-confirmation-${queryId}`}>
      <div>
        <p className={compact ? 'text-xs font-medium text-gray-600' : 'text-sm font-semibold text-gray-900'}>Did this resolve your query?</p>
        {!compact && <p className="text-xs text-gray-500">Your answer helps Qflow improve and closes the query when appropriate.</p>}
      </div>
      <div className="flex gap-2">
        <button type="button" disabled={saving} onClick={() => updateStatus('resolved')} className="inline-flex items-center gap-1 rounded-md border border-emerald-300 bg-white px-2.5 py-1 text-xs font-medium text-emerald-700 hover:bg-emerald-50 disabled:opacity-50">
          <CheckCircle size={13} /> Yes
        </button>
        <button type="button" disabled={saving} onClick={() => updateStatus('unresolved')} className="inline-flex items-center gap-1 rounded-md border border-rose-300 bg-white px-2.5 py-1 text-xs font-medium text-rose-700 hover:bg-rose-50 disabled:opacity-50">
          <XCircle size={13} /> No
        </button>
      </div>
    </div>
  );
};

export default ResolutionConfirmation;
